const stripe = Stripe("pk_test_xJNOSLhqbq9O63S6TajlCZ1t00kz2FZAvE");

import { getFunctions, httpsCallable } from "firebase/functions";
const functions = getFunctions();
const createPaymentIntent = httpsCallable(functions, "createPaymentIntent");


// ================== TO DO - IMPORTANT =====================
// MUST CHANGE THIS IN FUTURE TO BE A PRODUCT ID SO THAT THE
// PRICE IS NOT SENT FROM THE CLIENT
// ==========================================================
const orderValue = { value: 1499};

let elements;
let clientSecret;
let productId = "";
let productNameForMetadata = "";


document.addEventListener("DOMContentLoaded", (event) => {

  const urlParams = new URLSearchParams(window.location.search);
  productId = urlParams.get('pid');

  const productPrice = document.getElementById("product-price");
  const cartSubtotal = document.getElementById("cart-subtotal");
  const cartTotal = document.getElementById("cart-total");
  const productName = document.getElementById("product-name");
  const expressCheckout = document.getElementById("express-checkout");

  console.log("expressCheckout", expressCheckout);

  initialize();
  checkStatus();

  document.querySelector("#payment-form").addEventListener("submit", handleSubmit);

  function initialize() {

    console.log("In initialize productId = ", productId);

    createPaymentIntent({ chargeableAmount: orderValue, product_ID: productId }).then((result) => {
              console.log("objectReturnedFromFunction", result);
              console.log("messageReceived value", result.data.messageReceived);
              console.log("clientSecret value", result.data.clientSecret);
              console.log("productDetail value", result.data.productDetail);

              const productDetail = result.data.productDetail;

              productNameForMetadata = productDetail.product_name;
              productName.innerText = productDetail.product_name;
              productPrice.innerText = productDetail.product_display_price;
              cartSubtotal.innerText = productDetail.product_display_price;
              cartTotal.innerText =  productDetail.product_display_price;
              const allowExpressCheckout = productDetail.express_checkout;


              clientSecret = result.data.clientSecret;

              const appearance = {
                  theme: 'stripe',
                  labels: 'above',
                  variables: {
                      iconCardCvcColor: "#006e50",
                      colorPrimary: "#006e50"
                  },
            
              };

              elements = stripe.elements({ 
                  appearance,
                  clientSecret,
                  // fonts: [{
                  //     weight: 500
                  // }]
              });
          
              const paymentElementOptions = {
                  // layout: "tabs",
                  layout: {
                      type: 'accordion',
                      defaultCollapsed: false,
                      radios: true,
                      spacedAccordionItems: true
                    },
                  wallets: "never",
                  // options: {
                  //   paymentMethodConfiguration: "pmc_1OCm5oINNpqwvvT2fpvdSuGa"
                  // },
                  paymentMethodOrder: ['card', 'bacs_debit']
              };

              // Create and mount the Payment Element
              const paymentElement = elements.create("payment", paymentElementOptions);
              paymentElement.mount("#payment-element");

            const expressElementOptions = {
                wallets: {
                  applePay: 'always',
                  googlePay: 'always'
                },
                paymentMethodOrder: ['apple_pay', 'google_pay', 'paypal'],
                // buttonType: {
                //     applePay: 'buy',
                //     googlePay: 'buy',
                //     paypal: 'buynow'
                // }
                buttonHeight: 50,
                // buttonTheme: {
                //   applePay: 'white-outline'
                // }
            };

            if(allowExpressCheckout) {
              expressCheckout.style.display = "block";
              const expressElement = elements.create("expressCheckout", expressElementOptions);
              expressElement.mount("#express-element");
            }

            // Create and mount the Address Element in shipping mode
            const addressElement = elements.create("address", {
                mode: "shipping",
                fields: {
                  phone: "always"
                },
                display: {
                  name: "split"
                }
            });
            addressElement.mount("#address-element");

      });   
  }

});


async function handleSubmit(e) {
    e.preventDefault();
    setLoading(true);

    console.log("In handle submit, elements value is:", elements);

    const giftAidPreference = document.getElementById("giftAidPreference");
    const termsOptInInput = document.getElementById("termsPreference");
    const marketingPreference = document.getElementById("marketingPreference");
    const customerTitle = document.getElementById("customer-title");
    const customerDoB = document.getElementById("customer-dob");

    console.log("giftAidPreference", giftAidPreference.value, "termsOptInInput", termsOptInInput.value, "marketingPreference", marketingPreference.value );
  
    stripe.confirmPayment({
      elements,
      confirmParams: {
        // Make sure to change this to your payment completion page
        return_url: "https://rhs-payments.web.app/confirmation.html",
        receipt_email: "matthew.pearson@realtimeknowledge.com",
        payment_method_data: {
          metadata: {
            product_name: productNameForMetadata,
            product_ID: productId,
            customer_title: customerTitle.value,
            customer_dob: customerDoB.value,
            options_giftAidOptIn: giftAidPreference.value,
            options_termsOptIn: termsOptInInput.value,
            options_marketingOptIn: marketingPreference.value
          }
        }
      }

    }).then(function(result) {

      console.log("result", result);

        // This point will only be reached if there is an immediate error when
        // confirming the payment. Otherwise, your customer will be redirected to
        // your `return_url`. For some payment methods like iDEAL, your customer will
        // be redirected to an intermediate site first to authorize the payment, then
        // redirected to the `return_url`.

        if (result.error) {
            if (result.error.type === "card_error" || result.error.type === "validation_error") {
                showMessage(error.message);
              } else {
                showMessage("An unexpected error occurred.");
              }
        }
    });
    
    setLoading(false);
  }
  
  // Fetches the payment intent status after payment submission
  async function checkStatus() {

    const clientSecret = new URLSearchParams(window.location.search).get(
      "payment_intent_client_secret"
    );
  
    if (!clientSecret) {
      return;
    }
  
    const { paymentIntent } = await stripe.retrievePaymentIntent(clientSecret);

    console.log("Check status called, paymentIntent.status ", paymentIntent.status);

  
    switch (paymentIntent.status) {
      case "succeeded":
        showMessage("Payment succeeded!");
        break;
      case "processing":
        showMessage("Your payment is processing.");
        break;
      case "requires_payment_method":
        showMessage("Your payment was not successful, please try again.");
        break;
      default:
        showMessage("Something went wrong.");
        break;
    }

    console.log("Check status called, paymentIntent.status ", paymentIntent.status);
  }


  
  // ------- UI helpers -------
  
  function showMessage(messageText) {

    console.log("In showMessage:", messageText);

    const messageContainer = document.querySelector("#payment-message");
  
    messageContainer.classList.remove("hidden");
    messageContainer.textContent = messageText;
  
    setTimeout(function () {
      messageContainer.classList.add("hidden");
      messageContainer.textContent = "";
    }, 4000);
  }
  
  // Show a spinner on payment submission
  function setLoading(isLoading) {
    if (isLoading) {
      // Disable the button and show a spinner
      document.querySelector("#submit").disabled = true;
      document.querySelector("#spinner").classList.remove("hidden");
      document.querySelector("#button-text").classList.add("hidden");
    } else {
      document.querySelector("#submit").disabled = false;
      document.querySelector("#spinner").classList.add("hidden");
      document.querySelector("#button-text").classList.remove("hidden");
    }
  }
